import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
export function FinalCta() {
  return <section id="contacto" className="w-full bg-brand-yellow py-20 sm:py-28" data-id="element-66" data-mp="vghf3iqk01lu">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto w-full max-w-3xl px-5 text-center sm:px-8" data-id="element-67" data-mp="19f7cz0l765b9">
        <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-brand-ink sm:text-5xl" data-id="element-68" data-mp="1eets5fkl5vmp">
          Tu negocio puede estar online mañana.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-brand-ink/70 sm:text-lg" data-id="element-69" data-mp="1o3v6z2fea6z3">
          Escribinos hoy, contanos de qué se trata tu negocio y en 24 horas tenés tu página lista con
          dominio propio.
        </p>
        <a href="#contacto" className="mt-9 inline-flex items-center justify-center gap-2 rounded-full bg-brand-ink px-8 py-4 text-base font-bold text-white shadow-lift transition-transform hover:-translate-y-0.5" data-id="element-70" data-mp="1x51onets5ntx">
          <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-71" data-mp="s4xozgr5njm3" />
          Quiero mi página en 24 horas
        </a>
      </motion.div>
    </section>;
}